// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__az6VC","load":"Loader_load__lFBhu"};